import React from 'react'
import {
    Grid
  } from '@mui/material';
  import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import useStyles from '../styles';
import { theme } from '../../layout/MaterialLayout';


export default function Success(props) {
  const classes = useStyles();
  const successText = props.init && props.init.formTexts[props.textKey];

    return (
      <div className={classes.success} style={props.style}>
        <Grid container spacing={3}>
          <Grid item  size={{xs:12}}>
            <Card style={{backgroundColor:theme.palette.secondary.main, color:theme.palette.secondary.contrastText}} className={classes.info} variant="" color="secondary">
              <CardContent style={{paddingBottom:0}}>
                <div dangerouslySetInnerHTML={{__html:successText}}></div>
              </CardContent>
            </Card> 
            </Grid>
          </Grid>
        </div>
    )
}